"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internationalize = void 0;
//
// Return a new contrib with nls string values replaced
// with their mappings in config.nls[language][key], where an
// nls string value looks like "{{nls!key}}".  The lookup falls
// back to config.nls.root[key] if config.nls[language][key] is
// not found.  If there is no such mapping, the value is replaced
// with a placeholder indicating that the string is missing.
//
// Contrib objects are processed recursively, with handling for
// nested objects and arrays.
//
function internationalize(contrib, config, language) {
    const nls = config.nls || {};
    if (Array.isArray(contrib)) {
        return contrib.map(v => internationalize(v, config, language));
    }
    else if (typeof contrib === "object" && contrib) {
        const res = {};
        for (const [k, v] of Object.entries(contrib)) {
            res[k] = internationalize(v, config, language);
        }
        return res;
    }
    else if (typeof contrib === "string") {
        const match = /{{nls!(.*)}}/.exec(contrib);
        if (match) {
            const a = (nls[language] || {})[match[1]] ||
                (nls.root || {})[match[1]] ||
                `*missing-nls-string*${match[1]}`;
            return a;
        }
        else {
            return contrib;
        }
    }
    else {
        return contrib;
    }
}
exports.internationalize = internationalize;
